import { ClockPlus } from '@untitled-ui/icons-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Button from '@/components/ui/Button';

const ServicesHistoryActionCard = () => {
  const { t } = useTranslation('desktopPage');

  const navigate = useNavigate();

  return (
    <div className="bg-white h-[218px] sm:h-auto flex flex-col justify-between rounded-[32px] sm:flex-1 p-5">
      <div className="flex mb-2 justify-between items-center">
        <span className="text-[20px] text-[#595959] font-bold">{t('serviceHistory', { ns: 'header' })}</span>
        <ClockPlus className="w-6 h-6 text-[#9C8B7E]" />
      </div>
      <Button onClick={() => navigate('/service-history')} variant="primaryLight">
        {t('viewAll')}
      </Button>
    </div>
  );
};

export default ServicesHistoryActionCard;
